export default __webpack_public_path__ + "static/media/jeans.52155165.jpg";